import { Enums } from '@bode-canada/core';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import MapsMarkerHelper from '../helpers';

export default class ListingGroupMarkerRenderer {
  static render(cluster) {
    const [{ listing }] = cluster.markers;
    const isBodeListing = listing.origin === Enums.ListingOriginEnum.BODE;

    return new google.maps.Marker({
      icon: MapsMarkerHelper.getGroupListingIcon(listing),
      label: {
        text: cluster.count.toString(),
        fontSize: '14px',
        fontWeight: 'bold',
        color: isBodeListing ? StyleColorSchemeType.Black : StyleColorSchemeType.White,
      },
      position: cluster.position,
    });
  }
}
